import React, { Component } from "react";

// columns: array
// sortColumn: object
// onSort: function

class TableHeader extends Component {
  raiseSort = key => {
    const sortColumn = { ...this.props.sortColumn };
    if (sortColumn.key === key)
      sortColumn.order = sortColumn.order === "asc" ? "desc" : "asc";
    else {
      sortColumn.key = key;
      sortColumn.order = "asc";
    }
    this.props.onSort(sortColumn);
  };

  renderSortIcon = column => {
    const { sortColumn } = this.props;

    if (sortColumn === undefined || column.key !== sortColumn.key) return null;
    if (sortColumn.order === "asc") return <i className="fa fa-sort-asc" />;
    return <i className="fa fa-sort-desc" />;
  };

  render() {
    const { columns } = this.props;

    return (
      <thead>
        <tr className="row">
          {columns.map(column => (
            <th
              className={"clickable " + column.className}
              key={column.key}
              onClick={() => this.raiseSort(column.key)}
            >
              {column.label} {this.renderSortIcon(column)}
            </th>
          ))}
        </tr>
      </thead>
    );
  }
}

export default TableHeader;



// WEBPACK FOOTER //
// ./src/components/common/table/tableHeader.jsx